import React from 'react';
import cn from 'classnames';

import type { TTab } from './models';

/* Данный компонент используется для семантики в клиентском коде. */
export const Tab = ({ children, className, dataTestId, hidden = false, id, styles }: TTab) => {
    const stringId = String(id);

    return (
        <div
            className={cn(className, { [styles.hidden]: hidden })}
            data-test-id={dataTestId ?? stringId}
            id={stringId}
        >
            {children}
        </div>
    );
};
